import { render, staticRenderFns } from "./OrganizatiNei.vue?vue&type=template&id=67dcbe45&scoped=true"
import script from "./OrganizatiNei.vue?vue&type=script&lang=js"
export * from "./OrganizatiNei.vue?vue&type=script&lang=js"
import style0 from "./OrganizatiNei.vue?vue&type=style&index=0&id=67dcbe45&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcbe45",
  null
  
)

export default component.exports